import hasBetaFeature from "../stores/user/actions/hasBetaFeature";
import Feature from "../stores/user/Feature";

export default function isNewUIBetaUser() {
  return hasBetaFeature(Feature.betaMapUILayer);
}
